import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { renderBySource } from 'common/utils'
import Title from './Title'
import Questions from './Questions'
import Material from '../Material'
import styles from './index.css'
import ExplainByTitle from 'components/Practice/Material/ExplainByTitle.js'
import AdPosition from 'components/Practice/Material/AdPosition.js'
import ad1 from '../Material/ad1.jpg';
import ad2 from '../Material/ad2.jpg';

@withRouter
@observer(['practiceStore'])
export default class Main extends Component {
  renderSingleLayout () {
    const { practiceStore, location } = this.props

    return (
      <div className={styles.singleLay}>
        <Material
          material={practiceStore.material}
          category={practiceStore.category}
        />
        <div className={styles.questionContent}>
          <Questions />
          { practiceStore.show.answer ?
            <div className={styles.explain}>
              {
                renderBySource(location.query, 'ctqa', () => (
                  <ExplainByTitle ctqa={ practiceStore.ctqa} qid={ practiceStore.id} tipId={practiceStore.tipId} exam={this.props.exam}/>
                ))
              }
              {
                renderBySource(location.query, 'askTeacher', () => (
                  <AdPosition src={ad2} handleClick={ ()=> { practiceStore.toggleAskTeacher(true) } }/>
                ))
              }
            </div>
            : null
          }
        </div>
      </div>
    )
  }

  renderDoubleLayout () {
    const { practiceStore, location, params } = this.props
    if (params.exam && params.qid === "4489" && !location.query.source && location.query.source !== "smart") {
      return <p>该题已下线</p>
    } else {
      return (
        <div className={ styles.doubleLayout }>
          <div>
            <Material
              material={practiceStore.material}
              category={practiceStore.category}
              />
            {
              practiceStore.category === 'writing' ?
                (
                  practiceStore.detail.map((item,index)=> {
                    return (
                      <div key={index} className={styles.writingStem}>
                        <Material stem={item.question}/>
                      </div>
                    )
                  })
                ): null
            }
          </div>
  
          <div >
            <Questions />
            { practiceStore.show.answer ?
              <div className={styles.explain}>
                {
                  renderBySource(location.query, 'ctqa', () => (
                    <ExplainByTitle ctqa={ practiceStore.ctqa} qid={ practiceStore.id} tipId={practiceStore.tipId} exam={this.props.exam}/>
                  ))
                }
                {
                  renderBySource(location.query, 'askTeacher', () => (
                    <AdPosition src={ad1} handleClick={ () => { practiceStore.toggleAskTeacher(true) } }/>
                  ))
                }
              </div>
              : null
            }
          </div>
        </div>
      )
    }
  }

  render () {
    const { practiceStore } = this.props
    return (
      <div className={ styles.root }>
        <Title
          questionIds={practiceStore.questionIds}
          id={practiceStore.id}
          introduction={practiceStore.introduction}
        />
        { practiceStore.isSingleLayout ?
           this.renderSingleLayout() :
           this.renderDoubleLayout()
       }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Main/index.js
 **/